// extracted by mini-css-extract-plugin
var _1 = "calendarGraphic-module_btnContainer__OsiIB2";
var _2 = "calendarGraphic-module_courseDetailContainer__baWMoA";
var _3 = "calendarGraphic-module_currentCourse__mPzkky";
var _4 = "calendarGraphic-module_currentCourseName__OaKCpm";
var _5 = "calendarGraphic-module_currentCourseYear__mody5V";
var _6 = "calendarGraphic-module_disabledBth__zVcUB8";
var _7 = "calendarGraphic-module_tableContainer__tJyKly";
var _8 = "calendarGraphic-module_tableHeader__qLwz2M";
var _9 = "calendarGraphic-module_title__PN0lga";
export { _1 as "btnContainer", _2 as "courseDetailContainer", _3 as "currentCourse", _4 as "currentCourseName", _5 as "currentCourseYear", _6 as "disabledBth", _7 as "tableContainer", _8 as "tableHeader", _9 as "title" }
